import { Modal, Button } from 'antd';
import { useState } from 'react';

export default function ModalConfirm({
  btnText,
  data,
  handleDelete,
  msg = '',
  title,
  okText,
  okType,
  confirmText
}) {
  const [visible, setVisible] = useState(false);

  const confirmDelete = () => {
    handleDelete(data);
    setVisible(false);
  };

  return (
    <>
      <Button type="link" onClick={() => setVisible(true)}>
        {btnText}
      </Button>
      <Modal
        title={title || 'Confirm Action'}
        open={visible}
        onOk={confirmDelete}
        onCancel={() => setVisible(false)}
        okType={okType || 'danger'}
        okText={okText || btnText}
      >
        <p>{confirmText || `Are you sure you want to proceed with ${msg}${data?.id ? ` ${data.id}` : ''}?`}</p>
      </Modal>
    </>
  );
}
